import { FIELD_TYPES } from "./fieldTypes";

export const WIDGET_OPTION_FIELDS = {
  collapsibleResults: FIELD_TYPES.boolean,
  collapsibleResultsLimit: FIELD_TYPES.integer,
  fullComparatorUrl: FIELD_TYPES.string,
  initialShow: FIELD_TYPES.boolean,
  initialSort: FIELD_TYPES.string,
  show: FIELD_TYPES.boolean
};
